<!-- Headline -->
<div class="flex-row flex-justify-center strategy-header" *ngIf="!recheck">
  <div class="flex-col-4 flex-col-md-6 flex-col-sm-12">
    <h1 class="ui-headline">
      <ng-container *ngIf="currentAccount.step_status === 1; else riskNameTitle">
        {{ 'new_strategy.risk_screen.h2' | translate }}
      </ng-container>
      <ng-template #riskNameTitle>
        {{ 'new_strategy.risk_screen.slider.active.' + riskName | translate }} {{ 'new_strategy.risk_screen.h4-2' | translate }}
      </ng-template>
    </h1>
    <p *ngIf="visibleRiskSurveyQuestions.length > 1">{{ 'new_strategy.risk_screen.subtitle' | translate }}</p>
  </div>
</div>
<!-- Questions -->
<div class="flex-row flex-justify-center">
  <div class="flex-col-4 flex-col-md-6 flex-col-sm-12">
    <div class="questions-wrapper">
      <ng-container *ngFor="let riskQuestion of riskSurveyQuestions">
        <!-- Do not render willingnes question -->
        <ng-container *ngIf="showQuestion(riskQuestion)">
          <div class="question-box">
            <div class="white-box">
              <!-- Question title -->
              <div class="question-title">
                <p
                  [innerHtml]="riskQuestion.question_text"
                  (click)="riskQuestion.hasAnswer = !riskQuestion.hasAnswer"
                  [attr.data-cy]="'risk-question-title-' + riskQuestion.inyova_id"
                ></p>
                <ng-container *ngIf="riskQuestion.hint">
                  <app-ui-tooltip
                    [content]="riskQuestion.hint"
                    color="yellow"
                    size="small"
                    (mouseenter)="trackTooltip(riskQuestion.hint)"
                  ></app-ui-tooltip>
                </ng-container>
              </div>
              <!-- Single choice question -->
              <div
                [attr.data-cy]="'risk-questions-' + riskQuestion.inyova_id"
                class="flex-row"
                *ngIf="!riskQuestion.hasAnswer || recheck"
                [ngClass]="{ 'too-long': riskQuestion.too_long_options }"
              >
                <ng-container *ngFor="let riskOption of riskQuestion.survey_answer_options; let i = index">
                  <div
                    class="snippet"
                    [ngClass]="{
                      active: riskOption.id === riskQuestion.survey_customer_answer?.answer,
                      original: recheck && savedRiskAnswers.includes(riskOption.id),
                      small: riskQuestion.survey_answer_options.length === 3
                    }"
                    (click)="answerQuestion(riskQuestion, riskOption)"
                  >
                    {{ riskOption.option_text }}
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <!-- Warning box: Investing for less than 5 years -->
          <div
            class="increased-risk increased-risk-no-margin"
            data-cy="risk-low-investment-message"
            *ngIf="riskQuestion.inyova_id === RISK_CONSTANTS.SHORT_INVESTMENT.questionInyovaID && showShortInvestmentAgreed"
          >
            <div class="increased-risk-top">
              <span class="icon-i-warning"></span>
              <div>
                <p>{{ 'new_strategy.risk_screen.grey_box.attention' | translate }} {{ 'new_strategy.risk_screen.grey_box.p1' | translate }}</p>
                <p>
                  {{ 'new_strategy.risk_screen.grey_box.p2' | translate }}
                </p>
              </div>
            </div>

            <div class="increased-risk-bottom" (click)="updateShortInvestment()">
              <div class="checkbox-legal">
                <span [ngClass]="shortInvestmentAgreed ? 'icon-i-checkbox-on' : 'icon-i-checkbox-off'"></span>
              </div>
              <p>{{ 'new_strategy.risk_screen.grey_box.p3' | translate }}</p>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
<!-- Slider -->
<div data-cy="risk-slider" #sliderWrapper class="flex-row flex-justify-center" *ngIf="showStockSplitSlider && stockSplit">
  <div class="flex-col-4 flex-col-md-6 flex-col-sm-12">
    <p>{{ 'new_strategy.risk_screen.p' | translate }}</p>
    <app-strategy-stock-split-slider
      [bondRatio]="bondRatio"
      [customer]="customer"
      [insufficient]="false"
      [maxSliderValue]="4"
      [minSliderValue]="0"
      [pickedValue]="pickedValue"
      [recommendedClass]="recommendedClass"
      [riskName]="riskName"
      [stockRatio]="stockRatio"
      (update)="updateWillingnessQuestion($event)"
      [recheck]="recheck"
    ></app-strategy-stock-split-slider>
    <div class="increased-risk" *ngIf="showIncreasedRiskmMessage">
      <div class="increased-risk-top">
        <span class="icon-i-warning"></span>

        <p>
          <span [innerHtml]="'risk.box.too_risky_1-1' | translate"></span>
          <strong
            ><span class="lowercase">{{ 'new_strategy.risk_screen.slider.active.' + riskName | translate }}</span
            ><span [innerHtml]="'risk.box.too_risky_e' | translate"></span></strong
          >&nbsp;<span [innerHtml]="'risk.box.too_risky_1-2' | translate"></span>
        </p>
      </div>
      <div class="increased-risk-bottom" (click)="increasedRiskAcknowledgement = !increasedRiskAcknowledgement; enableSaveButtonCheck()">
        <div class="checkbox-legal">
          <span [ngClass]="increasedRiskAcknowledgement ? 'icon-i-checkbox-on' : 'icon-i-checkbox-off'"></span>
        </div>
        <p>{{ 'risk.box.too_risky_3' | translate }}</p>
      </div>
    </div>
  </div>
</div>
<!-- Footer -->
<app-footer>
  <ng-container *ngIf="!recheck; else showRecheck">
    <ng-container *ngIf="currentAccount.step_status < 5; else otherSteps">
      <button (click)="send()" class="ui-button" [class.loading]="isLoading" [disabled]="!enableSaveButton">
        <span class="icon-i-windmill"></span>
        {{ 'new_strategy.investment_screen.cta' | translate }}
      </button>
    </ng-container>
    <ng-template #otherSteps>
      <button (click)="continue()" class="ui-button" [class.loading]="isLoading" [disabled]="!enableSaveButton">
        <span class="icon-i-windmill"></span>
        {{ 'new_strategy.investment_screen.cta' | translate }}
      </button>
    </ng-template>
  </ng-container>
  <ng-template #showRecheck>
    <button (click)="discard()" class="ui-button secondary" [disabled]="isLoading">
      {{ 'new_strategy.notifications.risk_recheck.discard' | translate }}
    </button>
    <button (click)="sendRecheck()" class="ui-button" [class.loading]="isLoading" [disabled]="isLoading">
      <span class="icon-i-windmill"></span>
      {{ 'new_strategy.notifications.risk_recheck.save' | translate }}
    </button>
  </ng-template>
</app-footer>
